import { useTranslation } from "react-i18next";
import { AppText, FormInput } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import styles from "./styles.module.scss";

export const FormFields = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["form-fields"]}>
      <div className={styles["inputs-id"]}>
        <FormInput
          placeholder={t("registrationPage.userInfoStep.firstName")}
          name="firstName"
          className={styles["registration-input"]}
        />
        <FormInput
          placeholder={t("registrationPage.userInfoStep.lastName")}
          name="lastName"
          className={styles["registration-input"]}
        />
      </div>
      <FormInput
        placeholder={t("registrationPage.userInfoStep.phoneNumber")}
        name="phoneNumber"
        className={styles["registration-input"]}
      />
      <FormInput
        placeholder={t("registrationPage.userInfoStep.email")}
        name="email"
        className={styles["registration-input"]}
      />
      <FormInputPassword
        placeholder={t("registrationPage.userInfoStep.password")}
        name="password"
        className={styles["registration-input"]}
      />
      <FormInputPassword
        placeholder={t("registrationPage.userInfoStep.confirmPassword")}
        name="confirmPassword"
        className={styles["registration-input"]}
      />
      <AppText type="secondary" size="xs">
        {t("registrationPage.userInfoStep.passwordMustContain")}
      </AppText>
    </div>
  );
};
